module.exports = __webpack_public_path__ + "static/media/jogo-da-velha.2b0ea1e1.png";